// Animation constants
export const TOUR_ANIMATION_DURATION = 1000; // milliseconds
export const TOUR_ELEMENT_SHOW_DELAY = 300; // milliseconds

// Z-index constants
export const TOUR_OVERLAY_Z_INDEX = 10000;
export const JOYRIDE_Z_INDEX = 9000;

// CSS Selectors for popover detection
export const POPOVER_SELECTORS = [
  '[data-radix-popper-content-wrapper]',
  '.tour-popover-container',
  '[role="dialog"]',
  '[role="listbox"]',
] as const;

// Default overlay styles
export const DEFAULT_OVERLAY_COLOR = 'rgba(0, 0, 0, 0.2)';
export const DEFAULT_SPOTLIGHT_PADDING = 10;
export const DEFAULT_SPOTLIGHT_RADIUS = 16;

// Joyride configuration that we reuse
export const HIDDEN_JOYRIDE_STYLES = {
  options: {
    width: 0,
    zIndex: JOYRIDE_Z_INDEX,
  },
  tooltip: {
    display: 'none',
  },
  tooltipContainer: {
    display: 'none',
  },
  tooltipTitle: {
    display: 'none',
  },
  tooltipContent: {
    display: 'none',
  },
  buttonNext: {
    display: 'none',
  },
  buttonBack: {
    display: 'none',
  },
  buttonSkip: {
    display: 'none',
  },
} as const;
